/* Shopz theme scripts */
(function () {
  'use strict';
  if (window.__shopzLoaded) return; window.__shopzLoaded = true;
  document.documentElement.classList.add('shopz-anim');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var AR = /^ar/i.test(document.documentElement.lang || '') || /^\/ar(\/|$)/.test(location.pathname);
  var L = AR ? {
    'Removed from wishlist': 'تمت الإزالة من المفضلة',
    'Added to wishlist ♥': 'تمت الإضافة إلى المفضلة ♥',
    'Added to cart 🎉': 'تمت الإضافة إلى السلة 🎉',
    'Could not add': 'تعذّرت الإضافة',
    'Code copied: ': 'تم نسخ الرمز: '
  } : {};
  var tr = function (s) { return L[s] || s; };
  function isRtl(el) { return getComputedStyle(el || document.documentElement).direction === 'rtl'; }
  function toast(msg) {
    var t = $('#ShopzToast');
    if (!t) { var w = document.createElement('div'); w.className = 'shopz'; w.innerHTML = '<div class="sz-toast" id="ShopzToast" role="status" aria-live="polite"></div>'; document.body.appendChild(w); t = $('#ShopzToast'); void t.offsetWidth; }
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-show'); }, 2200);
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var els = $$('.sz-reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var track = en.target.closest('[data-car-track]');
        (track ? $$('.sz-reveal', track) : [en.target]).forEach(function (el) { el.classList.add('is-in'); io.unobserve(el); });
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- carousels ---------- */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (wrap) {
      var track = $('[data-car-track]', wrap); if (!track || wrap._car) return; wrap._car = true;
      var step = function () { return Math.max(track.clientWidth * 0.8, 200); };
      var prev = $('[data-car-prev]', wrap), next = $('[data-car-next]', wrap);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: (isRtl(track) ? 1 : -1) * step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: (isRtl(track) ? -1 : 1) * step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- hero slider ---------- */
  function initHero(root) {
    $$('[data-hero]', root).forEach(function (hero) {
      if (hero._hero) return; hero._hero = true;
      var slides = $$('.sz-hero__slide', hero); if (slides.length < 2) return;
      var navs = $$('[data-go]', hero), i = 0, timer;
      var auto = hero.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(hero.getAttribute('data-speed'), 10) || 6000;
      function go(n) {
        hero.classList.add('is-started');
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        navs.forEach(function (b) { b.classList.toggle('is-active', +b.getAttribute('data-go') === i); });
        restart();
      }
      function restart() { clearInterval(timer); if (auto) timer = setInterval(function () { go(i + 1); }, speed); }
      navs.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-go')); }); });
      var p = $('[data-hero-prev]', hero), nx = $('[data-hero-next]', hero);
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (nx) nx.addEventListener('click', function () { go(i + 1); });
      var x0 = null, vp = $('.sz-hero__viewport', hero);
      vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
        if (isRtl(hero)) dx = -dx; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); x0 = null;
      });
      hero.addEventListener('mouseenter', function () { clearInterval(timer); });
      hero.addEventListener('mouseleave', restart);
      restart();
      hero._go = go;
    });
  }

  /* ---------- product filter tabs ---------- */
  // A tab matches a card when any of its keys (collection, type, tag, brand) contains the tab name,
  // so "Ride-ons" also matches "ride-on-and-scooters" or "electric-ride-ons".
  function tabMatch(key, tags) {
    if (key === 'all') return true;
    var stem = key.replace(/-+$/, '').replace(/(ies)$/, 'y').replace(/s$/, '');
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i]; if (!t) continue;
      if (t === key || t.indexOf(stem) > -1) return true;
    }
    return false;
  }
  function initTabs(root) {
    $$('[data-filter]', root).forEach(function (sec) {
      var tabs = $$('[data-tab]', sec); if (!tabs.length || sec._tabs) return; sec._tabs = true;
      var items = $$('.sz-products__item', sec);
      var empty = $('[data-tabs-empty]', sec);
      var tagsOf = function (item) { var c = $('.sz-pcard', item); return (c && c.getAttribute('data-tags') || '').toLowerCase().split(/\s+/); };
      var count = function (key) { return items.filter(function (it) { return tabMatch(key, tagsOf(it)); }).length; };
      if (sec.hasAttribute('data-hide-empty') && !(window.Shopify && Shopify.designMode)) {
        tabs.forEach(function (t) { var k = t.getAttribute('data-tab'); if (k !== 'all' && !count(k)) t.hidden = true; });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-tab'), shown = 0;
          tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          items.forEach(function (item) {
            var on = tabMatch(key, tagsOf(item)); if (on) shown++;
            item.classList.toggle('is-hidden', !on);
          });
          if (empty) empty.hidden = shown > 0;
          var tr = $('[data-car-track]', sec); if (tr) tr.scrollTo({ left: 0, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- wishlist ---------- */
  function wishStore(v) {
    try { if (v) localStorage.setItem('shopz_wish', JSON.stringify(v)); return JSON.parse(localStorage.getItem('shopz_wish') || '[]'); }
    catch (e) { return v || []; }
  }
  function updateWishCount() {
    var c = wishStore().length;
    $$('[data-wish-count]').forEach(function (el) { el.textContent = c; el.toggleAttribute('data-zero', !c); });
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wish]'); if (!w) return;
    e.preventDefault();
    var card = w.closest('.sz-pcard'); var title = card ? ($('.sz-pcard__title', card) || {}).textContent : '';
    var list = wishStore(); var idx = list.indexOf(title);
    if (idx > -1) { list.splice(idx, 1); w.classList.remove('is-on'); toast(tr('Removed from wishlist')); }
    else { list.push(title); w.classList.add('is-on'); toast(tr('Added to wishlist ♥')); }
    wishStore(list); updateWishCount();
  });

  /* ---------- add to cart (AJAX, no page refresh) ---------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function themeCartUI() {
    // Dawn & most OS 2.0 themes expose <cart-drawer> or <cart-notification> with renderContents()
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification') || null;
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.toggleAttribute('data-zero', !n); });
    // common theme bubbles
    $$('.cart-count-bubble span[aria-hidden="true"], .cart-count, [data-cart-count-bubble], .cart-link__bubble-num').forEach(function (el) { el.textContent = n; });
  }
  document.addEventListener('click', function (e) {
    var demo = e.target.closest('button[data-add-demo]');
    if (demo) { e.preventDefault(); toast('Theme editor me is card ke liye product select karein'); return; }
    var b = e.target.closest('button[data-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    var ui = themeCartUI();
    var sections = [];
    if (ui && typeof ui.getSectionsToRender === 'function') {
      try { sections = ui.getSectionsToRender().map(function (x) { return x.section || x.id; }); } catch (err) {}
    }
    var body = { items: [{ id: +b.getAttribute('data-add'), quantity: 1 }] };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not add'); return d; }); })
      .then(function (added) {
        var item = (added.items && added.items[0]) || added;
        // let the theme open its own cart drawer / notification if it has one
        if (ui && typeof ui.renderContents === 'function' && added.sections) {
          try {
            var payload = Object.assign({}, item, { sections: added.sections, id: item.key || item.id, key: item.key });
            ui.renderContents(payload);
            if (ui.classList && ui.classList.contains('is-empty')) ui.classList.remove('is-empty');
          } catch (err) {}
        }
        document.dispatchEvent(new CustomEvent('shopz:cart:added', { detail: added }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        var c = $('.sz-header__cart'); if (c) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
        b.classList.add('is-added');
        setTimeout(function () { b.classList.remove('is-added'); }, 1600);
        if (!ui) toast(tr('Added to cart 🎉'));
      })
      .catch(function (err) { toast(err.message || tr('Could not add')); })
      .finally(function () { b.classList.remove('is-loading'); });
  });

  /* ---------- copy code ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]'); if (!b) return;
    var code = b.getAttribute('data-copy');
    var done = function () { b.classList.add('copied'); toast(tr('Code copied: ') + code); setTimeout(function () { b.classList.remove('copied'); }, 1600); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* ---------- drawer ---------- */
  document.addEventListener('click', function (e) {
    var d = $('[data-sz-drawer]'); if (!d) return;
    if (e.target.closest('[data-sz-drawer-open]')) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-sz-drawer-close]')) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var d = $('[data-sz-drawer].is-open'); if (d) d.querySelector('[data-sz-drawer-close]').click(); } });

  /* ---------- sticky header ----------
     Works inside any theme: uses a sentinel + getBoundingClientRect (so it also works when the
     theme scrolls a wrapper instead of the window) and sets inline fixed styles. */
  function hasBreakingAncestor(el) {
    // transform / filter / perspective / contain on an ancestor breaks position:fixed
    for (var n = el.parentElement; n && n !== document.documentElement; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if ((cs.transform && cs.transform !== 'none') || (cs.filter && cs.filter !== 'none') ||
          (cs.perspective && cs.perspective !== 'none') || /paint|layout|strict|content/.test(cs.contain || '') ||
          (cs.willChange || '').indexOf('transform') > -1) return n;
    }
    return null;
  }
  function initSticky() {
    var hdr = document.querySelector('[data-sz-header]'); if (!hdr || hdr._szSticky) return; hdr._szSticky = true;
    if (hdr.getAttribute('data-sticky') === 'false') return;

    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:0;margin:0;padding:0;border:0;';
    var spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.cssText = 'display:none;';
    hdr.parentNode.insertBefore(sentinel, hdr);
    hdr.parentNode.insertBefore(spacer, hdr);

    var fixed = false, ticking = false;
    function topOffset() {
      var bar = document.getElementById('admin-bar-iframe') || document.getElementById('preview-bar-iframe');
      return bar && bar.offsetHeight && getComputedStyle(bar).position === 'fixed' ? bar.offsetHeight : 0;
    }
    function fix() {
      var bad = hasBreakingAncestor(hdr);
      if (bad && !bad._szUnlocked) { bad._szUnlocked = true; bad.style.transform = 'none'; bad.style.filter = 'none'; bad.style.willChange = 'auto'; }
      var h = hdr.offsetHeight;
      spacer.style.cssText = 'display:block;height:' + h + 'px;';
      hdr.style.position = 'fixed';
      hdr.style.top = topOffset() + 'px';
      hdr.style.left = '0';
      hdr.style.right = '0';
      hdr.style.width = '100%';
      hdr.style.zIndex = '1000';
      hdr.classList.add('is-fixed', 'is-stuck');
      fixed = true;
    }
    function unfix() {
      hdr.style.position = hdr.style.top = hdr.style.left = hdr.style.right = hdr.style.width = hdr.style.zIndex = '';
      hdr.classList.remove('is-fixed', 'is-stuck');
      spacer.style.cssText = 'display:none;';
      fixed = false;
    }
    function update() {
      ticking = false;
      var past = sentinel.getBoundingClientRect().top < topOffset();
      if (past && !fixed) fix(); else if (!past && fixed) unfix();
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    // capture:true also catches scrolling of inner wrappers used by some themes
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { if (fixed) { unfix(); } update(); });
    window.addEventListener('load', update);
    update();
    window.ShopzSticky = { header: hdr, update: update };
  }

  /* ---------- policy "On this page" links ---------- */
  function initToc(root) {
    $$('[data-sz-toc]', root).forEach(function (nav) {
      if (nav._toc) return; nav._toc = true;
      var src = nav.parentNode.querySelector('[data-sz-toc-src]'); if (!src) return;
      var box0 = $('.sz-toc__links', nav); if (box0) box0.innerHTML = '';
      var hs = $$('h2, h3', src).filter(function (h) { return h.textContent.trim(); });
      if (hs.length < 2) return;
      var box = $('.sz-toc__links', nav);
      hs.forEach(function (h, i) {
        if (!h.id) h.id = 'sz-sec-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
        var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim(); box.appendChild(a);
      });
      nav.hidden = false;
    });
  }

  /* ---------- policy tabs (instant switch, no reload) ---------- */
  function initPolicyTabs(root) {
    $$('[data-sz-policy]', root).forEach(function (sec) {
      if (sec._pol) return; sec._pol = true;
      var tabs = $$('[data-sz-pol-tab]', sec), panels = $$('[data-sz-pol-panel]', sec);
      var title = $('[data-sz-pol-title]', sec), crumb = $('[data-sz-pol-crumb]', sec);
      var toc = $('[data-sz-toc]', sec);
      function rebuildToc(panel) {
        if (!toc) return;
        panels.forEach(function (p) { p.removeAttribute('data-sz-toc-src'); });
        panel.setAttribute('data-sz-toc-src', '');
        var box = $('.sz-toc__links', toc); box.innerHTML = ''; toc.hidden = true; toc._toc = false;
        initToc(sec);
      }
      function show(key, push) {
        var tab = tabs.filter(function (t) { return t.getAttribute('data-sz-pol-tab') === key; })[0];
        var panel = panels.filter(function (p) { return p.getAttribute('data-sz-pol-panel') === key; })[0];
        if (!tab || !panel) return false;
        tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p !== panel; });
        var t = panel.getAttribute('data-title') || tab.textContent.trim();
        if (title) title.textContent = t;
        if (crumb) crumb.textContent = t;
        sec.setAttribute('data-current', key);
        rebuildToc(panel);
        if (push) {
          var href = tab.getAttribute('href') || '';
          try {
            if (href.indexOf('/pages/') > -1) history.replaceState(null, '', href);
            else history.replaceState(null, '', location.pathname + location.search + '#' + key.replace(/_/g, '-'));
          } catch (e) {}
          var main = $('.sz-policy', sec);
          if (main && main.getBoundingClientRect().top < 0) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return true;
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey) return; // allow open in new tab
          if (show(t.getAttribute('data-sz-pol-tab'), true)) e.preventDefault();
        });
      });
      var h = (location.hash || '').replace('#', '').replace(/-/g, '_');
      if (h) show(h, false);
    });
  }

  function initAll(root) { initReveal(root); initCarousels(root); initHero(root); initTabs(root); initSticky(); initPolicyTabs(root); initToc(root); }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); updateWishCount(); });

  /* ---------- theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) { var h = e.target.querySelector && e.target.querySelector('[data-sz-header]'); if (h) h._szSticky = false; initAll(e.target); $$('.sz-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); }); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.sz-hero__slide'); var hero = e.target.closest('[data-hero]');
    if (slide && hero && hero._go) hero._go(+slide.getAttribute('data-slide'));
    e.target.classList && e.target.classList.add('is-in');
    $$('.sz-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
})();
